// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search[data-v-ba1a9494]{background-color:#fff;display:flex;align-items:center;overflow:hidden}.search i[data-v-ba1a9494]{flex:0 0 auto;padding:12px 0 15px 25px}.search input[data-v-ba1a9494]{width:100%;flex:1 1 auto;border:none;height:52px;padding:0 15px 0 10px;outline:none}", ""]);
// Exports
module.exports = exports;
